import {getAdapter} from './adapters/index'


class BotService {
  configure(config) {
    this.adapter = getAdapter(config)
  }

  getBotResponse = (message, global, module) => {
    return this.adapter.getBotResponse(message, global, module)
  }

  reset = () => {
    if (this.adapter && this.adapter.resetSession) {
      this.adapter.resetSession()
    }
  }

  getHistory = () => {
    return this.adapter.getHistory()
  }

  getConversationId = () => {
    return this.adapter.getConversationId()
  }

  poll = () => {
    return this.adapter.poll && this.adapter.poll()
  }

  init = () => this.adapter.init && this.adapter.init()

  translateErrorMessage = msg => (
    this.adapter.translateErrorMessage && this.adapter.translateErrorMessage(msg)
  )
}

let instance = new BotService()

export default instance



// WEBPACK FOOTER //
// ./src/App/services/BotService.js